import { PublicSite } from './public-site';

/** Signed-out fallback for protected application links. */
export function WelcomeLanding() {
  return <PublicSite page="welcome" />;
}
